<script>
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: null,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    disable: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  },
  computed: {
    commonFieldAttrs () {
      return {
        modelValue: this.modelValue,
        label: this.label,
        placeholder: this.placeholder,
        error: this.error ? true : undefined,
        errorMessage: this.errorMessage,
        name: this.name,
        disable: this.disable,
        required: this.required,
        autocomplete: this.autocomplete
      }
    },
    fieldAttrs () {
      return {
        modelValue: this.modelValue,
        label: this.labelFormatted,
        placeholder: this.placeholder,
        error: this.error ? true : undefined,
        errorMessage: this.errorMessage,
        name: this.name,
        disable: this.disable,
        required: this.required,
        autocomplete: this.autocomplete,
      }
    },
    labelFormatted(){
      return this.required ? `* ${this.label}` : this.label
    },
    allAttrs () {
      return {
        ...this.$attrs,
        ...this.fieldAttrs
      }
    },
    hasValue () {
      if (this.modelValue === null) {
        return false
      }

      if (this.modelValue === '') {
        return false
      }

      if (typeof this.modelValue === 'undefined') {
        return false
      }

      if (Array.isArray(this.modelValue)) {
        return this.modelValue.length > 0
      }

      return true
    },
    requiredRules () {
      if (this.disable || !this.required) {
        return []
      }

      return [
        (v) => {
          if (this.hasValue) {
            return true
          }
          return `${this.label} is een verplicht veld.`
        }
      ]
    }
  }
}
</script>
